import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerData.css';
import { DateTimeHelper,TranslateGender } from 'utils-lib';
import { EditFormButton,TextField,SelectField,DateField,AutocompleteField,MessageBox,Checkbox,Icon,ConfirmBox } from 'component-lib';
import { CustomerModel, RequestAjaxClass, StreetsModel, GenderModel, AdditionalAddressesModel, ContractsModel } from 'models-lib';

var moment = require('moment');
        moment().format();

var additionaladdressesAvailable =false

class CustomerData extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.CustomerId = this.props.id;
        this.state.Edit = false;

        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
    
        this.CustomerModel = new CustomerModel([this],null, this.Request);
        
        this.StreetsModel = new StreetsModel([this], null, this.Request);

        this.Request3 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.AdditionalAddressesModel = new AdditionalAddressesModel([this],null,this.Request3);

        this.Request3.setApiUrl(Vas.ApiUrl);
        this.Request3.setApiKey(Vas.ApiKey);
        this.Request3.setAuth(true);

        // eslint-disable-next-line no-unused-expressions
        this.Request2 = new RequestAjaxClass((error)=>{this.props.ErrorHandling ? this.props.ErrorHandling(error) : '';},null);
        this.GenderModel = new GenderModel([this], null, this.Request2);

        this.Request2.setAuth(false);
        this.Request2.setApiKey(Vas.ApiKey);
        this.Request2.setApiUrl(Vas.ApiUrl);

        this.GenderModel.GetGender();

        this.AdditionalAddressesModel.GetAdditionalAddressesByCustomerId(this.CustomerId);

        this.IconConfig = Vas.Config.ShowIconsOrButtons;
    }

    componentDidMount(){
       
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setAuth(true);

      if(this.refs.name &&this.refs.firstName && this.refs.dateOfBirth && this.refs.zip && this.refs.city && this.refs.houseNumber && this.refs.gender && this.refs.street){
        let reqFields = [this.refs.name, this.refs.firstName,this.refs.dateOfBirth,this.refs.zip, this.refs.city,this.refs.houseNumber, this.refs.street];

        this.setState({ requiredFields:reqFields, 
          requiredSelectField:[this.refs.gender] });
        this.load(false);
      }
    }

    componentDidUpdate()
    {
      if (this.state.Edit === false)
      {
          this.setFieldStates(false);
      }
      else
      {
          this.setFieldStates(true);
      }

      this.LogoClick();

      this.FontSizeClick();
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "Customer"){

          //Hier das Geburtsdatum in localstorage schreiben
          localStorage.setItem("DayOfBirth", this.CustomerModel.Customer.DateOfBirth);

          $("#LoadingIcon").removeClass().addClass('hide'); 
          this.setCustomer(this.CustomerModel.Customer);
          
        }
        else if(observer === "Streets"){
          me.refs.street.setState({ Data: this.StreetsModel.Streets, Icon :'',placeholder:'' });
          me.setState({oldZip: this.StreetsModel.PostCode, oldCity: this.StreetsModel.City });
        } 
        else if(observer === "CustomerPUT"){
          $("#LoadingIcon").removeClass().addClass('hide');
          this.setCustomer(this.CustomerModel.Customer);
          
          if(localStorage.getItem("vas_role") === "3"){
            if(this.CustomerId === localStorage.getItem('vas_customerId')){
              localStorage.setItem("vas_name", this.CustomerModel.Customer.Name1);
              localStorage.setItem("vas_firstName", this.CustomerModel.Customer.Name2);
              localStorage.setItem('vas_username',this.CustomerModel.Customer.Name2 + " " + this.CustomerModel.Customer.Name1);
            }
          }
          /*if(localStorage.getItem("vas_role") === "1"){
            localStorage.setItem("vas_name", this.CustomerModel.Customer.Name1);
            localStorage.setItem("vas_firstName", this.CustomerModel.Customer.Name2);
            localStorage.setItem('vas_username',this.CustomerModel.Customer.Name2 + " " + this.CustomerModel.Customer.Name1);
          }else if(localStorage.getItem("vas_role") === "3"){
            localStorage.setItem("employee_name1", this.CustomerModel.Customer.Name1);
            localStorage.setItem("employee_name2", this.CustomerModel.Customer.Name2);
          }*/
          
          //TransdevMenue.setState();
          me.props.reference.GetCustomer();
          
        }
        else if(observer === "Gender"){
          
            let genderSelection = []
        
            if(this.GenderModel.Gender.length > 0){
  
              let genderArray = this.GenderModel.Gender;
  
              if(genderArray.length === 2) {
                genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] }];
              } else if(genderArray.length === 3){
                genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] },{ Key: genderArray[2], Display: 'divers' }];
              }
            }
            this.setState({GenderValues : genderSelection});
            this.refs.gender.setState({Data:genderSelection});
          
        }
        else if(observer === "AdditionalAddresses"){
          additionaladdressesAvailable = me.AdditionalAddressesModel.AdditionalAddresses.length > 0 ? true : false;
        }
      });
    }

    setCustomer(Customer){
      this.setState({},()=>{
        let me = this;
        if (me.refs){

          document.getElementById('CustomerNumber').value = Customer.CustomerNumber;
          document.getElementById('Salutation').value = Customer.Salutation;
          document.getElementById('Name1').value = Customer.Name1;
          document.getElementById('Name2').value = Customer.Name2;
          document.getElementById('Gender').value = TranslateGender.Translate(Customer.Gender,localStorage.getItem('vas_language'));
          document.getElementById('DateOfBirth').value = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(Customer.DateOfBirth,true,localStorage.getItem('vas_language')));
          document.getElementById('Zip').value = Customer.PostCode;
          document.getElementById('City').value = Customer.City;
          document.getElementById('Street').value = Customer.Street;
          document.getElementById('AddressAddition').value = Customer.Name3;
          document.getElementById('HouseNumber').value = Customer.HouseNumber;
          document.getElementById('HouseNumberAddition').value = Customer.HouseNumberAddition;
          document.getElementById('Phone').value = Customer.Phone;
          document.getElementById('PhoneBusiness').value = Customer.Phone2;
          document.getElementById('Fax').value = Customer.Fax;
          document.getElementById('Email').value = Customer.Email;

          document.getElementById("NoMail").checked = Customer.MarketingEmail;
          document.getElementById("NoPhone").checked = Customer.MarketingPhone;
          document.getElementById("NoPost").checked = Customer.MarketingPost;
          this.setMarketingPhone(Customer.MarketingPhone);

        }
        $("#LoadingIcon").removeClass().addClass('hide');
      });
    }

    setMarketingPhone(marketing){
      let reqFields = this.state.requiredFields;
      if(marketing === true){
        reqFields.push(this.refs.phone);
        this.refs.phone.setState({ isrequired : true});
      }else{
        let idx = -1;
        for(let i = 0; i< reqFields.length; i++){
          if(reqFields[i] === this.refs.phone){
            idx = i;
          }
        }
        if(idx > -1){
          reqFields.splice(idx,1);
          this.refs.phone.setState({ isrequired : false});
        }
      }
      this.setState({requiredFields : reqFields});
    }

    setFieldStates(value){
      if(value !== undefined && value !== null){
        if(value === true || value === false){
          let me = this;
          if(me.refs.adressAddition){
            me.refs.adressAddition.setState({ editable:value });
          }
          if(me.refs.zip){
            me.refs.zip.setState({ editable:value });
          }
          if(me.refs.city){
            me.refs.city.setState({ editable:value });
          }
          if(me.refs.houseNumber){
            me.refs.houseNumber.setState({ editable:value });
          }
          if(me.refs.phone){
            me.refs.phone.setState({ editable:value });
          }
          if(me.refs.phoneBusiness){
            me.refs.phoneBusiness.setState({ editable:value });
          }
          if(me.refs.fax){
            me.refs.fax.setState({ editable:value });
          }
          if(me.refs.street){
            me.refs.street.setState({ editable:value });
          }
          if(me.refs.houseNumberAddition){
            me.refs.houseNumberAddition.setState({ editable:value });
          }
          if(me.refs.gender){
            me.refs.gender.setState({ Placeholder:me.state.Gender });
          }
          
          if(document.getElementById("Name1")){
            document.getElementById("Name1").onselectstart = function(){return value;};
            document.getElementById("Name1").onmousedown = function(){return value;};
          }
          if(document.getElementById("Name1")){
            document.getElementById("Name2").onselectstart = function(){return value;};
            document.getElementById("Name2").onmousedown = function(){return value;};
          }
          if(document.getElementById("Gender")){
            document.getElementById("Gender").onselectstart = function(){return value;};
            document.getElementById("Gender").onmousedown = function(){return value;};
          }
          if(document.getElementById("DateOfBirth")){
            document.getElementById("DateOfBirth").onselectstart = function(){return value;};
            document.getElementById("DateOfBirth").onmousedown = function(){return value;};
          }
          if(document.getElementById("AddressAddition")){
            document.getElementById("AddressAddition").onselectstart = function(){return value;};
            document.getElementById("AddressAddition").onmousedown = function(){return value;};
          }
          if(document.getElementById("Zip")){
            document.getElementById("Zip").onselectstart = function(){return value;};
            document.getElementById("Zip").onmousedown = function(){return value;};
          }
          if(document.getElementById("City")){
            document.getElementById("City").onselectstart = function(){return value;};
            document.getElementById("City").onmousedown = function(){return value;};
          }
          if(document.getElementById("Street")){
            document.getElementById("Street").onselectstart = function(){return value;};
            document.getElementById("Street").onmousedown = function(){return value;};
          }
          if(document.getElementById("HouseNumber")){
            document.getElementById("HouseNumber").onselectstart = function(){return value;};
            document.getElementById("HouseNumber").onmousedown = function(){return value;};
          }
          if(document.getElementById("Phone")){
            document.getElementById("Phone").onselectstart = function(){return value;};
            document.getElementById("Phone").onmousedown = function(){return value;};
          }
          if(document.getElementById("PhoneBusiness")){
            document.getElementById("PhoneBusiness").onselectstart = function(){return value;};
            document.getElementById("PhoneBusiness").onmousedown = function(){return value;};
          }
          if(document.getElementById("Fax")){
            document.getElementById("Fax").onselectstart = function(){return value;};
            document.getElementById("Fax").onmousedown = function(){return value;};
          }
          if(document.getElementById("HouseNumberAddition")){
            document.getElementById("HouseNumberAddition").onselectstart = function(){return value;};
            document.getElementById("HouseNumberAddition").onmousedown = function(){return value;};
          }
        }
      }
    }

    load(error){
      
          $("#LoadingIcon").removeClass().addClass('loaderSmall');
          this.Request.setErrorHandler(()=>{
            $("#LoadingIcon").removeClass().addClass('hide');
          });
          this.CustomerModel.GetCustomerById(this.CustomerId);
                  
          if(document.getElementById("Salutation")){
            document.getElementById("Salutation").onselectstart = function(){return false;};
            document.getElementById("Salutation").onmousedown = function(){return false;};
          }
          if(document.getElementById("CustomerNumber")){
            document.getElementById("CustomerNumber").onselectstart = function(){return false;};
            document.getElementById("CustomerNumber").onmousedown = function(){return false;};
          }
          if(document.getElementById("Email")){
            document.getElementById("Email").onselectstart = function(){return false;};
            document.getElementById("Email").onmousedown = function(){return false;};
          }
        // eslint-disable-next-line
        document.onselectstart = new Function ("return false");
    }

    Cancel(){
      this.setState({oldZip:'',oldCity:''},()=>{
        this.load();
      });
    }

    getStreets()
    {
      let me = this;
      me.refs.street.setState({ Icon:"Loop" });

      if ((me.CustomerModel.Customer.PostCode !== me.state.oldZip)||(me.CustomerModel.Customer.City !== me.state.oldCity)){
        me.refs.street.setState({ Data: [], Icon : '' });
        document.getElementById("Street").value = '';
      }

      if (me.CustomerModel.Customer.City || me.CustomerModel.Customer.PostCode){
        let city = '';
        let zip = '';
        if (me.CustomerModel.Customer.City){
          city=me.CustomerModel.Customer.City;
        } else {
          city = document.getElementById("City").placeholder;
        }
        if (me.CustomerModel.Customer.PostCode){
          zip=me.CustomerModel.Customer.PostCode;
        } else {
          zip = document.getElementById("Zip").placeholder;
        }

        this.StreetsModel.GetStreets(city,zip);
      }
    };

    checkFields(){
        let count;
        if (this.state.requiredFields  && this.state.requiredSelectField){
          count = this.state.requiredFields.length +  this.state.requiredSelectField.length;
          let filled = 0; //Anzahl der korrekt gefüllten Feldern 
          for (let i = 0;i < this.state.requiredFields.length;i++){
            if (this.state.requiredFields[i]){
                if (document.getElementById(this.state.requiredFields[i].props.Id).value.length > 0 || document.getElementById(this.state.requiredFields[i].props.Id).placeholder.length > 0){
                  filled++;
                }
            }
          }

          for (let k = 0; k < this.state.requiredSelectField.length;k++){
            if (this.state.requiredSelectField[k]){
              if (document.getElementById(this.state.requiredSelectField[k].props.Id).selectedIndex > 0){
                    filled++;
                }
            }
          }
          if (filled < count){
              return false;
          } else {
            if(this.CustomerModel.Customer.MarketingPhone === true){
              if(this.CustomerModel.Customer.Phone.length > 0){
                return true;
              }else{
                return "phone"
              }
            }else{
              return true;
            }
          }
        }
    }

    CustomerUpdate()
    {   
      let result = this.checkFields(); 
      if ( result === true){
        this.PostCustomer();
        this.setState({oldCity:'',oldZip:''});
      } else if (result === false){
        ReactDOM.render(<MessageBox
          Message={Vas.Resources.Labels["NotAllFields"]}
          Title={Vas.Resources.Titles["Note"]}
        />,document.getElementById('messageContainer'));
        this.load(false);
      }else if( result === "phone"){
        ReactDOM.render(<MessageBox
          Message={Vas.Resources.Labels["MarketingPhoneAddPhone"]}
          Title={Vas.Resources.Titles["Note"]}
        />,document.getElementById('messageContainer'));
        this.load(false);
        
      }

      if(additionaladdressesAvailable){
        ReactDOM.render(<ConfirmBox
          AppURL={Vas.ApplicationUrl}
          LabelConfirm={Vas.Resources.Titles["Note"]}
          LabelCancel={Vas.Resources.Labels["No"]}
          LabelConfirmButton={Vas.Resources.Labels["Yes"]}
          modal={true}
          MessageText={Vas.Resources.Labels["ConfirmAdditionalAddressChange"]}
          Click={()=>{this.GetViewAdditionalAddresses();}} /> , document.getElementById('messageContainer'));
      }
    }

    PostCustomer(){

      this.CustomerModel.Customer.Street = this.CustomerModel.Customer.Street = "" ? $("#Street").val() : this.CustomerModel.Customer.Street;
      this.CustomerModel.Customer.HouseNumber = this.CustomerModel.Customer.HouseNumber = "" ? $("#HouseNumber").val() : this.CustomerModel.Customer.HouseNumber;

      if (this.CustomerModel.Customer.Name1.length > 0 && this.CustomerModel.Customer.Name2.length > 0 && 
        DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true, localStorage.getItem('vas_language')).isValid() === true){

        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        this.Request.setErrorHandler(()=>{
          this.load(false);
        });

        //this.CustomerModel.Customer.Gender = $('#Gender').val();

        let sal = '';

        switch (localStorage.getItem("vas_language")) {
          case 'de':
              if ($('#Gender').val() === "weiblich") {
                  sal = "Frau";
              } else if($('#Gender').val() === "männlich"){
                  sal = "Herr";
              }
              break;
          case 'en':
              if ($('#Gender').val() === "female") {
                  sal = "Mrs";
              } else if($('#Gender').val() === "male"){
                  sal = "Mr";
              }
              break;
          default:
              break;
        }

        this.CustomerModel.Customer.Salutation = sal;

        this.CustomerModel.UpdateCustomer();
      }
    }

    GetViewAdditionalAddresses(){

      //VAS-29919: Wenn in der Confirmbox auf Ja geklickt wird, wird hier die currentView zu den zus. Adressen gespeichert und CustomerCard aufgerufen
      localStorage.setItem("currentView","AdditionalAdresses");

      Vas.GetView("CustomerCard",{Id:this.CustomerId},true);
    }

    checkCountry(){
        if ($("#Country").val().length > 3){
            $("#Country").val($("#Country").val().substr(0,$("#Country").val().length-1));
            ReactDOM.render(<MessageBox
              AppURL={Vas.ApplicationUrl}
              Message={Vas.Resources.Labels["CountryLenth"]}
              Title={Vas.Resources.Titles["Note"]}
                />,document.getElementById('messageContainer'));
        }
    }

    Switch(){
      if (this.refs.noMail && this.refs.noPhone && this.refs.noPost){
        if(this.state.Edit === true){
          this.CustomerModel.Customer.MarketingEmail = document.getElementById("NoMail").checked;
          this.CustomerModel.Customer.MarketingPhone = document.getElementById("NoPhone").checked;
          this.CustomerModel.Customer.MarketingPost = document.getElementById("NoPost").checked;

          //this.PostCustomer();
        }else{
          document.getElementById("NoMail").checked = this.CustomerModel.Customer.MarketingEmail;
          document.getElementById("NoPhone").checked = this.CustomerModel.Customer.MarketingPhone;
          document.getElementById("NoPost").checked = this.CustomerModel.Customer.MarketingPost;
          ReactDOM.render(<MessageBox
            AppURL={Vas.ApplicationUrl}
            Message={Vas.Resources.Labels["EditData"]}
            Title={Vas.Resources.Titles["Note"]}
              />,document.getElementById('messageContainer'));
        }
        
      }
    }

    showChangeEmail(){
      Vas.GetView("ChangeMail", {CustomerId: this.props.id, Email: this.CustomerModel.Customer.Email},true);
      //ReactDOM.render(<ChangeEmail />,document.getElementById('popupContainer'));
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');

      if(kontrastNumber == "true"){
        $('.extendedButton').attr('style', 'background-color: #1d5c87; width: 100px;');
        $('.checkbox').attr('style', 'accent-color: #1d5c87; float: left; margin-left: 0px;');
        $('.focusedCheckBox').attr('style', 'accent-color: #1d5c87; float: left; margin-left: 0px;');
      }
    }

    FontSizeClick(){
      var schriftgröße = localStorage.getItem('Schriftgröße');
  
      //Schriftgröße bei Klick in 2er Schritten erhöhen
      //$('#customerCardHeadline').removeClass("Schriftgröße_22").addClass("Schriftgröße_17");
  
        if(schriftgröße != null){
              switch(schriftgröße){
                case "0":
                  $('#customerCardHeadline').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");
                  $('.extendedButton').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                break;
                case "1":
                  $('#customerCardHeadline').removeClass("Schriftgröße_22").addClass("Schriftgröße_17");
                  $('.extendedButton').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");                      
                break;
                case "2":
                  $('#customerCardHeadline').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('.extendedButton').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");        
  
                break;
                case "3":
                  $('#customerCardHeadline').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");  
                  $('.extendedButton').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                break;
                case "4":
                  $('#customerCardHeadline').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                  $('.extendedButton').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                break;
                case "5":
                  $('#customerCardHeadline').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                  $('.extendedButton').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                break;
              }
        }
    };

    render()
    {     
        let maxValue = moment();

        let gender = '';
        let birth = '';
        let street = '';
        let name = '';
        let firstName = '';
        let adressAddition = '';
        let zip = '';
        let city = '';
        let houseNumber = '';
        let phone = ''; 
        let phoneBusiness = '';
        let fax = '';
        let houseNumberAddition = '';

        gender = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          Editable={false} 
          Id={"Gender"} 
          ref={"gender"} 
          Label={Vas.Resources.Labels["Gender"]}  
        />);
        birth = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          Editable={false} 
          Id={"DateOfBirth"} 
          ref={"dateOfBirth"} 
          Label={Vas.Resources.Labels["DateOfBirth"]} 
        />);
        street = (<AutocompleteField 
          AppURL={Vas.ApplicationUrl} 
          TitleMessageFalseStreet={Vas.Resources.Labels["Error"]} 
          MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]}  
          Modus={"Street"} 
          ref={"street"} 
          Id={"Street"} 
          Float={'left'} 
          editable={false} 
          Label={Vas.Resources.Labels["Street"]} 
          Data={this.StreetsModel.Streets} 
          OnBlur={()=>{ this.CustomerModel.Customer.Street = $("#Street").val() ; }} 
          Tooltip={Vas.Resources.Tooltips["Street"]} 
          TimeOutTime={Vas.TimeOutTime}
          IsRequired={true}
        />);
        name = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"name"} 
          Editable={false} 
          Id={"Name1"} 
          Label={Vas.Resources.Labels["Name"]} 
          OnBlur={()=>{
            if ($("#Name1").val().length === 0){$("#Name1").val(this.CustomerModel.Customer.Name1);} else {this.CustomerModel.Customer.Name1 = $("#Name1").val();}
          }}
          Modus={"Name"} 
          IsRequired={true}
        />);
        firstName = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"firstName"} 
          Editable={false} 
          Id={"Name2"} 
          Label={Vas.Resources.Labels["FirstName"]} 
          OnBlur={()=>{if ($("#Name2").val().length === 0){$("#Name2").val(this.CustomerModel.Customer.Name2);} else {this.CustomerModel.Customer.Name2 = $("#Name2").val(); }}}
          Modus={"Name"}
          IsRequired={true}
        />);
        adressAddition = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"adressAddition"} 
          Editable={false} 
          Id={"AddressAddition"} 
          Label={Vas.Resources.Labels["AdditionAdress"]} 
          OnChange={()=>{ this.CustomerModel.Customer.Name3 = $("#AddressAddition").val(); }}
          IsRequired={false}
        />);
        zip = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"zip"} 
          Id={"Zip"} 
          Label={Vas.Resources.Labels["Zip"]} 
          Editable={false} 
          OnBlur={()=>{if ($("#Zip").val().length !== 5){
            $("#Zip").val(this.CustomerModel.Customer.PostCode);
            ReactDOM.render(<MessageBox 
              Message={Vas.Resources.Labels["PLZNote"]} 
              Title={Vas.Resources.Titles["Note"]} />
                ,document.getElementById('messageContainer'));
          } else {
            this.CustomerModel.Customer.PostCode = $("#Zip").val();this.getStreets();
          }
        }}
          Modus={"Number"}
          IsRequired={true}
        />);
        city = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"city"} 
          Id={"City"} 
          Label={Vas.Resources.Labels["Place"]} 
          Editable={false} 
          OnChange={()=>{if ($("#City").val().length < 0)
                        {$("#City").val(this.CustomerModel.Customer.City);} 
                        else {this.CustomerModel.Customer.City = $("#City").val();this.getStreets();}}}
          IsRequired={true}
          />);
        houseNumber = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"houseNumber"} 
          Id={"HouseNumber"} 
          Editable={false} 
          Label={Vas.Resources.Labels["HouseNumber"]} 
          OnBlur={()=>{if ($("#HouseNumber").val().length === 0){$("#HouseNumber").val(this.CustomerModel.Customer.HouseNumber);} else {this.CustomerModel.Customer.HouseNumber = $("#HouseNumber").val();}}}
          Modus={"Number"}
          IsRequired={true}
        />);
        phone = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"phone"} 
          Id={"Phone"} 
          Editable={false} 
          Label={Vas.Resources.Labels["Phone"]} 
          OnChange={()=>{ this.CustomerModel.Customer.Phone = $("#Phone").val(); }}
          Modus={"TelNumber"}
        />);
        phoneBusiness = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"phoneBusiness"} 
          Id={"PhoneBusiness"} 
          Editable={false} 
          Label={Vas.Resources.Labels["PhoneBusiness"]} 
          OnChange={()=>{ this.CustomerModel.Customer.Phone2 = $("#PhoneBusiness").val(); }} 
          Modus={"TelNumber"}
        />);
        fax = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"fax"} 
          Id={"Fax"} 
          Editable={false} 
          Label={Vas.Resources.Labels["Fax"]} 
          OnBlur={()=>{ this.CustomerModel.Customer.Fax= $("#Fax").val() ; }} 
          Modus={"TelNumber"}
        />);
        houseNumberAddition = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"houseNumberAddition"} 
          Id={"HouseNumberAddition"} 
          Editable={false} 
          Label={Vas.Resources.Labels["HouseNumberAddition"]} 
          OnChange={()=>{ this.CustomerModel.Customer.HouseNumberAddition = $("#HouseNumberAddition").val(); }}
          
        />);


        if (this.state.Edit === true){  

            
            gender = (<SelectField 
              AppURL={Vas.ApplicationUrl} 
              ref={"gender"} 
              IsRequired={true} 
              Id={"Gender"} 
              Default={TranslateGender.Translate(this.CustomerModel.Customer.Gender, localStorage.getItem('vas_language'))} 
              Label={Vas.Resources.Labels["Gender"]} 
              Data={ this.state.GenderValues } 
              OnChange={()=>{
                if(document.getElementById('Gender').selectedIndex > 0){
                  this.CustomerModel.Customer.Gender = TranslateGender.Translate($("#Gender").val(),'de');
                }
              }}
              Tooltip={Vas.Resources.Tooltips["Gender"]} 
              Selected={false} 
              Picker={false}
               />);
        }  

        let noMailtrue = <div></div>;
        let noMailfalse = <div></div>;
        
        if (this.CustomerModel.Customer.MarketingEmail !== undefined){
          if (this.CustomerModel.Customer.MarketingEmail === false){
            noMailtrue = (<Checkbox
              Id={"NoMail"}
              ref={"noMail"}
              onClick={()=>{this.Switch();}} />);
          } else {
            noMailfalse = (<Checkbox
              Id={"NoMail"}
              ref={"noMail"}
              onClick={()=>{this.Switch();}}
               />);
          }
        }

        let noPhonetrue = <div></div>;
        let noPhonefalse = <div></div>;
        
        if (this.CustomerModel.Customer.MarketingPhone !== undefined){
          if (this.CustomerModel.Customer.MarketingPhone === false){
            noPhonetrue = (<Checkbox
              Id={"NoPhone"}
              ref={"noPhone"}
              onClick={()=>{this.Switch();}} />);
          } else {
            noPhonefalse = (<Checkbox
              Id={"NoPhone"}
              ref={"noPhone"}
              onClick={()=>{this.Switch();}}
               />);
          }
        }

        let noPosttrue = <div></div>;
        let noPostfalse = <div></div>;
        
        if (this.CustomerModel.Customer.MarketingPost !== undefined){
          if (this.CustomerModel.Customer.MarketingPost === false){
            noPosttrue = (<Checkbox
              Id={"NoPost"}
              ref={"noPost"}
              onClick={()=>{this.Switch();}} />);
          } else {
            noPostfalse = (<Checkbox
              Id={"NoPost"}
              ref={"noPost"}
              onClick={()=>{this.Switch();}}
               />);
          }
        }
        let classNameEditForm = "customerDataContainerEditButton";
        if(this.IconConfig.ShowIcons === false){
          if (this.state.Edit === true){ 
            classNameEditForm = "customerDataContainerEditButtonNoIconsEdit";
          }else{
            classNameEditForm = "customerDataContainerEditButtonNoIcons";
          }
           
        }

        let emailIcon = <div></div>;
      
        if(localStorage.getItem('vas_role') == '1'){
          emailIcon = (<Icon
            Color={"black"} 
            Name={"Create"}
            ref={"emailIcon"} 
            Size={24}
            Align={"right"}
            OnClick={()=>{this.showChangeEmail();}}
          />);
        }

        return (
        
          <div style={{ marginTop:10, marginLeft:10 }}>

              <div>
                <div className={"customerCardSubTitle"}><b>{Vas.Resources.Labels["PersonalData"]}</b></div>
                <div className={classNameEditForm}>
                  <EditFormButton 
                  ref={"EditFormButton"} 
                  base={this} 
                  curr={this.state} 
                  id={this.props.id}
                  ShowIcons={this.IconConfig.ShowIcons} />
                </div>
              </div>
              <div className={"customerDataContainer"}>
                <div className={"customerDataContainerLarge"}>
                  <TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Editable={false} 
                  Id={"CustomerNumber"} 
                  ref={"CustomerNumber"} 
                  Label={Vas.Resources.Labels["CustomerNumber"]} 
                  Value={this.state.CustomerNumber} />
                </div>
              
                <div className={"customerDataContainerLarge"}>
                  <TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Editable={false} 
                  Id={"Salutation"} 
                  ref={"Salutation"} 
                  Label={Vas.Resources.Labels["Salutation"]} 
                   /> 
                </div>
                
              </div>
              <div className={"customerDataContainer"}>
                <div className={"customerDataContainerLarge"}>{name}</div>
                <div className={"customerDataContainerSmall"}>{firstName}</div>
              </div>
              <div className={"customerDataContainer"}>
                <div className={"customerDataContainerLarge"}>{birth}</div>
                <div className={"customerDataContainerSmall"}>{gender}</div>
              </div>
              <div className={"customerDataContainer"}>
                <div className={"customerDataContainerLarge"}>{zip}</div>
                <div className={"customerDataContainerSmall"}>{city}</div>
              </div>
              <div className={"customerDataContainer"}>
                  <div className={"customerDataContainerLarge"}>{street}</div>
              </div>
              <div className={"customerDataContainer"}>
                  <div className={"customerDataContainerLarge"}>{houseNumber}</div>
                  <div className={"customerDataContainerSmall"}>{houseNumberAddition}</div>
              </div>
              <div className={"customerDataContainer"}>
                  <div className={"customerDataContainerLarge"}>{adressAddition}</div>
              </div>
              <div className={"customerDataContainer"}>
                  <div className={"customerDataContainerLarge"}>{phone}</div>
                  <div className={"customerDataContainerLarge"}>{phoneBusiness}</div>

              </div>
              <div className={"customerDataContainer"}>
                  
                  <div className={"customerDataContainerSmall"}>{fax}</div>
                </div>
              <div className={"customerDataContainer"}>
                <div className={"customerDataContainerLarge"} style={{ width: '430px'}}>
                  <TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Id={"Email"} 
                  ref={"email"} 
                  Label={Vas.Resources.Labels["Email"]} 
                  Value={this.state.Email} />
                  {emailIcon}
                </div>
              </div>

              <div className={"customerDataContainer"}>
                <div className={"customerDataContainerLarge"}>
                  <br/>
                  <table style={{width:'400px'}}>
                    <tbody>
                      <tr>
                        <td>
                          <div id={"MarketingComplience"}>
                            <br />
                            <b>{Vas.Resources.Labels["MarketingComplience"]} </b>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table style={{width:'135px'}}>
                    <tbody>
                      
                      <tr>
                        <td >
                        <div style={{ width: '95px', float: 'left' }}>{Vas.Resources.Labels["MarketingComplienceMail"]}:</div>
                        
                        </td>
                        <td>
                          {noMailtrue}{noMailfalse}
                        </td>
                      </tr>

                      <tr>
                        <td >
                          <div style={{ width: '95px', float: 'left' }}>{Vas.Resources.Labels["MarketingCompliencePhone"]}:</div>
                        </td>
                        <td>
                          {noPhonetrue}{noPhonefalse}
                        </td>
                      </tr>

                      <tr>
                        <td >
                          <div style={{ width: '95px', float: 'left' }}>{Vas.Resources.Labels["MarketingCompliencePost"]}:</div>
                        </td>
                        <td>
                          {noPosttrue}{noPostfalse}
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                
              </div>

          </div>
        );
    }
}
export default CustomerData;
